<template>
  <v-row>
    <v-col>
      <v-row align="center">
        <v-col class="text-h5 gray--text" cols="auto"> Terapêuticas </v-col>

        <v-col cols="4">
          <v-combobox
            v-model="template"
            label="Protocolo"
            dense
            outlined
            hide-details
            background-color="white"
            :items="orderedTemplates"
            item-text="name"
            @change="activeTemplate"
            :disabled="disabled"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-btn
            color="light-blue"
            dark
            @click="showSurgeryTherapyForm = true"
            :disabled="disabled"
          >
            Terapêutica
          </v-btn>
        </v-col>
      </v-row>

      <SurgeryTherapyForm
        :showSurgeryTherapyForm="showSurgeryTherapyForm"
        :toggleShow="() => (showSurgeryTherapyForm = !showSurgeryTherapyForm)"
        :surgery="surgery"
        :surgeryMoment="surgeryMoment"
        :refreshSurgery="refreshSurgery"
        :disabled="disabled"
      />

      <v-row v-if="lodash.isEmpty(therapies)" justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Sem terapêuticas
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-else>
        <TherapyListItem
          v-for="therapy in therapies"
          :key="therapy.id"
          :therapy="therapy"
          :surgery="surgery"
          :allowEdit="allowEdit"
          :allowDelete="allowDelete"
          :refreshSurgery="refreshSurgery"
          :disabled="disabled"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import TherapyListItem from "@/components/surgery/therapy/list/item.vue";
import SurgeryTherapyForm from "@/components/surgery/therapy/form.vue";

export default {
  name: "AttendanceTherapyList",
  props: {
    surgery: Object,
    surgeryMoment: String,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    refreshSurgery: Function,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TherapyListItem,
    SurgeryTherapyForm,
  },
  data() {
    return {
      showSurgeryTherapyForm: false,
      template: "",
    };
  },
  apollo: {
    templates: {
      query: require("@/graphql/template/templates.gql"),
      variables() {
        return {
          templateType: "surgery_therapy",
        };
      },
    },
  },
  computed: {
    therapies() {
      return this.lodash.filter(this.surgery.therapies, {
        surgeryMoment: this.surgeryMoment,
      });
    },
    filteredTemplates() {
      return this.lodash.filter(
        this.templates,
        function (template) {
          return template.items
            .map(
              (item) =>
                item.buildingInformation.surgery_moment === this.surgeryMoment
            )
            .reduce((result, value) => result || value);
        }.bind(this)
      );
    },
    orderedTemplates() {
      if(!this.filteredTemplates) return
      return this.lodash.orderBy(
        this.filteredTemplates,
        [(e) => e.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")],
        ["asc"]
      );
    },
  },
  methods: {
    activeTemplate() {
      if (!this.allowEdit) return;
      if (!this.template?.id) return;

      this.apolloMutate({
        mutation: require("@/graphql/surgery/active_therapy_template.gql"),
        variables: {
          surgeryId: this.surgery.id,
          templateId: this.template.id,
        },
      }).then(() => {
        this.template = "";
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
